// extracted by mini-css-extract-plugin
export default {"footer":"footer__8lwGA","spacer":"spacer__gWScN"};